import React from 'react'

export default function FaceFeature({ scaleX, fill }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M43.0399 0.770004L41.58 0C41.58 0 35.7499 10.76 21.5199 10.76C7.2799 10.76 1.45996 0 1.45996 0L0 0.770004C2.84 14.04 15.5499 17.26 21.5199 17.26C27.4899 17.26 40.2399 13.95 43.0399 0.770004Z"
        fill={fill}
      />
      <path d="M19.66 10.6899L18.77 17.0499" stroke="#EDB414" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M16.0601 10.2L14.29 16.06" stroke="#EDB414" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M12.7301 9.22998L10.3901 14.46" stroke="#EDB414" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M9.73035 7.83008L6.86035 12.1201" stroke="#EDB414" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M7.16992 6.22998L4.18994 9.50998" stroke="#EDB414" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M4.96021 4.33008L2.18018 6.62009" stroke="#EDB414" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M3.02002 2.23999L0.810059 3.56" stroke="#EDB414" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M23.3799 10.6899L24.2698 17.0499" stroke="#EDB414" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M26.98 10.2L28.74 16.06" stroke="#EDB414" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M30.3096 9.22998L32.6495 14.46" stroke="#EDB414" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M33.3096 7.83008L36.1796 12.1201" stroke="#EDB414" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M35.8701 6.22998L38.8501 9.50998" stroke="#EDB414" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M38.0698 4.33008L40.8499 6.62009" stroke="#EDB414" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M40.0195 2.23999L42.2296 3.56" stroke="#EDB414" strokeWidth="0.5" strokeMiterlimit="10" />
    </g>
  )
}
